import _ from 'lodash';
import Liveboards from 'models/location/liveboards';

export default {
  fromUrlParameters({ type, groups, teams, timezone }) {
    return _.omitBy(
      {
        type: type && type.toUpperCase(),
        routingGroupIds: groups && _.filter(groups),
        teamIds: teams && _.filter(teams),
        timezone,
      },
      _.isNil
    );
  },

  getPath(liveboards) {
    return liveboards.type === Liveboards.defaultType ? '/liveboards' : `/liveboards/${liveboards.type.toLowerCase()}`;
  },

  getQueryParams(liveboards) {
    let queryParams = {};
    if (liveboards.routingGroupIds) {
      queryParams.groups = liveboards.routingGroupIds;
    }
    if (liveboards.teamIds) {
      queryParams.teams = liveboards.teamIds;
    }
    if (liveboards.timezone) {
      queryParams.timezone = liveboards.timezone;
    }
    return queryParams;
  },
};



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/url_converters/liveboards_url_converter.js